import { createFileRoute } from "@tanstack/react-router";

import { WhatsAppGroupsPage } from "@/pages/Admin/WhatsAppGroupsPage";

export const Route = createFileRoute("/app/admin/whatsapp-groups/")({
  component: WhatsAppGroupsPage,
});
